import styled from 'styled-components'

export const Blocks = styled.div`
  padding: 0.8rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`
